// src/pages/administracion/config/adminConfig.tsx
import { ReactElement } from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  Business as BusinessIcon,
  LocationOn as LocationOnIcon,
  AccountBalance as AccountBalanceIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  LocalShipping as LocalShippingIcon,
  Work as WorkIcon,
  LocationCity as LocationCityIcon,
  Security as SecurityIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

export type AdminCategory = 'organizacion' | 'personal' | 'comercial' | 'sistema';

interface AdminConfig {
  title: string;
  description: string;
  icon: ReactElement;
  path: string;
  category: AdminCategory;
}

export const ADMIN_CONFIGS: Record<string, AdminConfig> = {
  'empresas': {
    title: 'Empresas',
    description: 'Gestión de empresas del sistema',
    icon: <BusinessIcon />,
    path: 'empresas',
    category: 'organizacion'
  },
  'sucursales': {
    title: 'Sucursales',
    description: 'Administración de sucursales',
    icon: <LocationCityIcon />,
    path: 'sucursales',
    category: 'organizacion'
  },
  'areas': {
    title: 'Áreas',
    description: 'Gestión de áreas organizacionales',
    icon: <LocationOnIcon />,
    path: 'areas',
    category: 'organizacion'
  },
  'cargos': {
    title: 'Cargos',
    description: 'Administración de cargos',
    icon: <WorkIcon />,
    path: 'cargos',
    category: 'personal'
  },
  'empleados': {
    title: 'Empleados',
    description: 'Gestión de empleados',
    icon: <PeopleIcon />,
    path: 'empleados',
    category: 'personal'
  },
  'clientes': {
    title: 'Clientes',
    description: 'Administración de clientes',
    icon: <PersonIcon />,
    path: 'clientes',
    category: 'comercial'
  },
  'proveedores': {
    title: 'Proveedores',
    description: 'Gestión de proveedores',
    icon: <LocalShippingIcon />,
    path: 'proveedores',
    category: 'comercial'
  },
  'impuestos': {
    title: 'Impuestos',
    description: 'Configuración de impuestos',
    icon: <AccountBalanceIcon />,
    path: 'impuestos',
    category: 'comercial'
  },
  'accesos': {
    title: 'Accesos',
    description: 'Módulos permitidos por rol',
    icon: <SecurityIcon />,
    path: 'accesos',
    category: 'sistema'
  },
  'configuracion-email': {
    title: 'Correo SMTP',
    description: 'Configuración del servidor de correo para envío de facturas y cotizaciones',
    icon: <EmailIcon />,
    path: 'configuracion-email',
    category: 'sistema'
  },
  'facturacion-electronica': {
    title: 'Facturación Electrónica',
    description: 'Resoluciones DIAN y proveedor tecnológico',
    icon: <ReceiptLongIcon />,
    path: 'facturacion-electronica',
    category: 'comercial'
  },
} as const;

export type AdminConfigKey = keyof typeof ADMIN_CONFIGS;

export const CATEGORY_LABELS: Record<AdminCategory, string> = {
  organizacion: 'Organización',
  personal: 'Personal',
  comercial: 'Comercial',
  sistema: 'Sistema'
};

export const CATEGORY_COLORS: Record<AdminCategory, string> = {
  organizacion: '#3498db',
  personal: '#e74c3c',
  comercial: '#27ae60',
  sistema: '#9b59b6'
};